import { RootState } from '../../store';

export const getSuccessCreatedSelector = (state: RootState) => state?.ticketReducer?.successCreated;
